// @flow
import React from 'react';
import HitLabel from '../HitLabel/HitLabel';
import type {Badge} from '../HitInfo/HitInfo';
import {FREE_CANCELLATION} from '../../constants/badges';

type Props = {
    showIncludesTaxesAndFeesMessage?: boolean,
    premierPartnerBadge?: ?Badge,
    rankedBadges: Badge[],
    brand?: string,
    tooltipParentNode?: Object,
    isDesktop?: boolean,
    showNewCancellationPolicy?: boolean
};

const RankedBadgesCollection = ({
    showIncludesTaxesAndFeesMessage,
    premierPartnerBadge,
    rankedBadges,
    brand,
    tooltipParentNode,
    isDesktop,
    showNewCancellationPolicy
}: Props) => {
    let badges;
    if (showNewCancellationPolicy) {
        badges = rankedBadges.filter((badge) => badge.id !== FREE_CANCELLATION);
    } else {
        badges = rankedBadges;
    }

    return (
        badges.length > 0 && (
            <div className="HitInfo__labels">
                {showIncludesTaxesAndFeesMessage && premierPartnerBadge && (
                    <HitLabel
                        brand={brand}
                        id={premierPartnerBadge.id}
                        label={premierPartnerBadge.name}
                        parentNode={tooltipParentNode}
                        toolTipText={premierPartnerBadge.helpText}
                    />
                )}
                {badges.map((badge, index) =>
                    isDesktop ? (
                        <HitLabel
                            key={index}
                            brand={brand}
                            id={badge.id}
                            label={badge.name}
                            toolTipText={badge.helpText}
                            parentNode={tooltipParentNode}
                        />
                    ) : (
                        <HitLabel
                            key={index}
                            id={badge.id}
                            label={badge.name}
                        />
                    )
                )}
            </div>
        )
    );
};

export default RankedBadgesCollection;
